import React, {Component} from 'react';
import {
    AppRegistry,
    StyleSheet,
    Text,
    View, processColor
} from 'react-native';

import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMGroupBarChart from "../../../../customviews/chart/HMGroupBarChart";
import HMStackedBarChart from "../../../../customviews/chart/HMStackedBarChart";


let container = null;

class ChartSatiaScreen extends Component {

    constructor() {
        super();


    }

    render() {
        let {item, type} = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params : {}
        return (

            <View style={{flex: 1}}>

                <HMActionBarSatia menu props={this.props} headerVisibility statusBarTransparent text={"نمودار"}
                                  back
                                  onBackPress={() => this.props.navigation.pop()}/>

                {/*     <HMGroupBarChart/>*/}

                {/*
                <HMStackedBarChart/>
*/}
                {
                    this.ChartView(type,item)
                }


            </View>
        );
    }

    ChartView(type, item) {

        switch (type) {
            case  "GroupBarChart":

                return <HMGroupBarChart

                    item={item ? item : [
                        {
                            "NAME": "INTERNET",
                            "FNAME": "اینترنت بین الملل",
                            "IN": 5659874562,
                            "OUT": 15987453214,
                            "CREDITUSED": 125645,
                            "URL": ""
                        },
                        {
                            "NAME": "INTERNAL",
                            "FNAME": "سایت های داخلی",
                            "IN": 12548963584,
                            "OUT": 1358745699,
                            "CREDITUSED": 266412,
                            "URL": "https:\/\/icip.ito.gov.ir\/index.php\/site\/page\/view\/list_ip"
                        },
                        {
                            "NAME": "VOD",
                            "FNAME": "تلویزیون اینترنتی",
                            "IN": 28656487543,
                            "OUT": 3258457896,
                            "CREDITUSED": 125874,
                            "URL": "https:\/\/icip.ito.gov.ir\/index.php\/site\/page\/view\/list_ip"
                        },
                        {
                            "NAME": "SATIA",
                            "FNAME": "رایگانها",
                            "IN": 895656456,
                            "OUT": 655646,
                            "CREDITUSED": 148759,
                            "URL": ""
                        },
                        {
                            "NAME": "MESSENGER",
                            "FNAME": "پیام رسان داخلی",
                            "IN": 64645655,
                            "OUT": 0,
                            "CREDITUSED": 64587,
                            "URL": ""
                        }
                    ]}
                />;
            case  "StackedBarChart":


                return <HMStackedBarChart


                    item={item ? item :
                        [
                            {
                                "YM": {
                                    "Year": 1399,
                                    "Month": 7
                                },
                                "MONTH": "24 روز از مهرماه",
                                "IN": 36189293752,
                                "OUT": 3287908317,
                                "CREDITUSED": 144580.04425626755,
                                "BEGINDATE": "1399\/7\/1",
                                "ENDDATE": "1399\/7\/24"
                            },
                            {
                                "YM": {
                                    "Year": 1399,
                                    "Month": 6
                                },
                                "MONTH": "شهریور",
                                "IN": 39809241505,
                                "OUT": 5339810025,
                                "CREDITUSED": 169129.65653301237,
                                "BEGINDATE": "1399\/6\/1",
                                "ENDDATE": "1399\/6\/31"
                            },
                            {
                                "YM": {
                                    "Year": 1399,
                                    "Month": 5
                                },
                                "MONTH": "مرداد",
                                "IN": 41768774920,
                                "OUT": 3062643313,
                                "CREDITUSED": 164538.76142395969,
                                "BEGINDATE": "1399\/5\/1",
                                "ENDDATE": "1399\/5\/31"
                            }
                        ]
                    }


                />;
            default:
                return <HMStackedBarChart


                    item={item ? item :
                        [
                            {
                                "YM": {
                                    "Year": 1399,
                                    "Month": 7
                                },
                                "MONTH": "24 روز از مهرماه",
                                "IN": 36189293752,
                                "OUT": 3287908317,
                                "CREDITUSED": 144580.04425626755,
                                "BEGINDATE": "1399\/7\/1",
                                "ENDDATE": "1399\/7\/24"
                            },
                            {
                                "YM": {
                                    "Year": 1399,
                                    "Month": 6
                                },
                                "MONTH": "شهریور",
                                "IN": 39809241505,
                                "OUT": 5339810025,
                                "CREDITUSED": 169129.65653301237,
                                "BEGINDATE": "1399\/6\/1",
                                "ENDDATE": "1399\/6\/31"
                            },
                            {
                                "YM": {
                                    "Year": 1399,
                                    "Month": 5
                                },
                                "MONTH": "مرداد",
                                "IN": 41768774920,
                                "OUT": 3062643313,
                                "CREDITUSED": 164538.76142395969,
                                "BEGINDATE": "1399\/5\/1",
                                "ENDDATE": "1399\/5\/31"
                            }
                        ]
                    }


                />;

        }
    }
}


export default ChartSatiaScreen;

